import { useQuery } from 'react-query';
import { useLayoutEffect, useRef } from 'react';
import { getPanelDetails } from './api';
import { RIGHT_PANEL_MOBILE_BREAKPOINT } from '../../constants';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { useRefDispatch } from 'contexts/RefContext';
import useScreenDims from 'hooks/useScreenDims';
import SideModal from 'components/ManualToolModal';
import SolarDesktopView from './RightSidePanel/SolarDesktopView';
import SolarMobileView from './RightSidePanel/SolarMobileView';
import AdjustShadingMenu from 'components/AdjustShadingMenu';
import { useSaveDesign } from 'hooks/api/useSaveDesign';

export default function DisplayEnergy() {
	const { org } = useSelector((state: RootState) => state.roofData.data);
	const refDispatch = useRefDispatch();
	const { width: screenWidth } = useScreenDims();
	const showMobileView = screenWidth <= RIGHT_PANEL_MOBILE_BREAKPOINT;
	const bottomDivRef = useRef<HTMLDivElement | null>(null);

	const { save, status: saveStatus } = useSaveDesign('SOLAR');

	const getPanelDetailsForOrg = useQuery(
		`panelsKeys-${org.panelKeys?.length || 0}`,
		async () => {
			return await getPanelDetails();
		},
		{
			refetchOnWindowFocus: false,
			enabled: !!org.panelKeys?.length,
			refetchOnMount: false,
			retry: 2,
		}
	);

	useLayoutEffect(() => {
		refDispatch({ type: 'KONVA_BOTTOM_DIV_REF', payload: { ref: bottomDivRef } });
	}, [refDispatch]);

	const SolarSidePanelComponent = showMobileView ? SolarMobileView : SolarDesktopView;

	return (
		<>
			<SolarSidePanelComponent
				saveStatus={saveStatus}
				getPanelDetailsForOrg={getPanelDetailsForOrg}
				savePanels={save}
				ref={bottomDivRef}
			/>
			<SideModal />
			<AdjustShadingMenu/>
		</>
	);
}
